import { render, staticRenderFns } from "./MainMenuList.vue?vue&type=template&id=0bb17341&"
import script from "./MainMenuList.vue?vue&type=script&lang=js&"
export * from "./MainMenuList.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports